
export enum PaymentMethodEntityType {
  acss_debit= 'acss_debit',
  affirm= 'affirm',
  afterpay_clearpay= 'afterpay_clearpay',
  alipay= 'alipay',
  alma= 'alma',
  amazon_pay= 'amazon_pay',
  au_becs_debit= 'au_becs_debit',
  bacs_debit= 'bacs_debit',
  bancontact= 'bancontact',
  billie= 'billie',
  blik= 'blik',
  boleto= 'boleto',
  card= 'card',
  card_present= 'card_present',
  cashapp= 'cashapp',
  customer_balance= 'customer_balance',
  eps= 'eps',
  fpx= 'fpx',
  giropay= 'giropay',
  grabpay= 'grabpay',
  ideal= 'ideal',
  interac_present= 'interac_present',
  kakao_pay= 'kakao_pay',
  klarna= 'klarna',
  konbini= 'konbini',
  kr_card= 'kr_card',
  link= 'link',
  mobilepay= 'mobilepay',
  multibanco= 'multibanco',
  naver_pay= 'naver_pay',
  nz_bank_account= 'nz_bank_account',
  oxxo= 'oxxo',
  p24= 'p24',
  pay_by_bank= 'pay_by_bank',
  payco= 'payco',
  paynow= 'paynow',
  paypal= 'paypal',
  pix= 'pix',
  promptpay= 'promptpay',
  revolut_pay= 'revolut_pay',
  samsung_pay= 'samsung_pay',
  satispay= 'satispay',
  sepa_debit= 'sepa_debit',
  sofort= 'sofort',
  swish= 'swish',
  twint= 'twint',
  us_bank_account= 'us_bank_account',
  wechat_pay= 'wechat_pay',
  zip= 'zip',

}